import { renderJsonLd } from '@/content/crawler-content';
import { renderPageJsonLd, type SeoPage } from '@/content/seo-pages';

const homeMetadata = {
  title: 'Software Built Around Your Problem | Atlas AG',
  description:
    'Atlas AG builds purpose-fit software around the problem your business needs solved, so the solution fits the way you actually work.',
  url: 'https://atlasag.co/',
};

function setMeta(name: string, content: string) {
  let element = document.querySelector(`meta[name="${name}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute('name', name);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
}

function setProperty(property: string, content: string) {
  let element = document.querySelector(`meta[property="${property}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute('property', property);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
}

function setCanonical(url: string) {
  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    document.head.appendChild(canonical);
  }
  canonical.setAttribute('href', url);
}

function setStructuredData(value: string) {
  let structuredData = document.getElementById('atlas-jsonld') as HTMLScriptElement | null;
  if (!structuredData) {
    structuredData = document.createElement('script');
    structuredData.id = 'atlas-jsonld';
    structuredData.type = 'application/ld+json';
    document.head.appendChild(structuredData);
  }
  structuredData.textContent = value;
}

function applyMetadata({
  title,
  description,
  url,
  type,
  structuredData,
}: {
  title: string;
  description: string;
  url: string;
  type: 'website' | 'article';
  structuredData: string;
}) {
  document.title = title;
  setCanonical(url);
  setMeta('description', description);
  setProperty('og:title', title);
  setProperty('og:description', description);
  setProperty('og:url', url);
  setProperty('og:type', type);
  setProperty('og:site_name', 'Atlas AG');
  setMeta('twitter:title', title);
  setMeta('twitter:description', description);
  setStructuredData(structuredData);
}

export function applyHomeMetadata() {
  applyMetadata({
    ...homeMetadata,
    type: 'website',
    structuredData: renderJsonLd(),
  });
}

export function applyPageMetadata(page: SeoPage) {
  applyMetadata({
    title: page.title,
    description: page.description,
    url: `https://atlasag.co${page.path}`,
    type: page.kind === 'case-study' ? 'article' : 'website',
    structuredData: JSON.stringify(renderPageJsonLd(page)),
  });
}